<template>
  <div class="toggle">
    <p class="toggle__title text-tiny" v-if="showTitle">
      {{ title }}
    </p>

    <div class="toggle__items">
      <button
          type="button"
          class="toggle__item"
          :class="{'toggle__item--active': item.active}"
          v-for="(item, idx) in items"
          :key="idx"
          @click="toggle(idx)">
        <Image :data="item.image"/>
      </button>
    </div>

    <p class="toggle__name" v-if="activeName">
      {{ activeName }}
    </p>
  </div>
</template>

<script>
import Image from '@/components/Image/Image.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Toggle',
  components: { Image },
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      items: null,
    };
  },
  computed: {
    ...mapGetters({
      // src текущей медитации
      audioSrc: 'app/getCurrentAudioSrc',
    }),

    activeName() {
      if (!this.items || !this.items.length) return '';

      return this.items.find((item) => item.active)?.name || '';
    },
    title() {
      return this.data?.title || '';
    },
    showTitle() {
      return !(!this.title || !this.items || this.items.length < 2);
    },
  },
  methods: {
    ...mapMutations({
      // выбор диктора
      setCurrenAudioSrc: 'app/setCurrentAudioSrc',
    }),

    toggle(id) {
      this.items.forEach((item, idx) => {
        if (id === idx) {
          this.items[idx].active = true;

          // сохраняем в ls code текущего спикера
          localStorage.setItem('NLMK_SPEAKER_CODE', this.items[idx].code);
        } else {
          this.items[idx].active = false;
        }
      });

      const { audio } = this.items[id];

      // сработает, если src изменился
      if (this.audioSrc !== audio) {
        this.$emit('onToggle');
      }

      this.setCurrenAudioSrc(audio);
    },
  },
  mounted() {
    this.items = this.data.items.map((item) => ({
      ...item,
    }));

    // code первого диктора
    const firstSpeakerCode = this.items[0].code;

    if (!localStorage.getItem('NLMK_SPEAKER_CODE')) {
      // выбор первого диктора по умолчанию, если он не был выбран ранее
      localStorage.setItem('NLMK_SPEAKER_CODE', firstSpeakerCode);

      this.items[0].active = true;

      // src первого спикера
      this.setCurrenAudioSrc(this.items[0].audio);
    } else {
      const currentSpeakerCode = localStorage.getItem('NLMK_SPEAKER_CODE');
      // есть ли такой code в списке спикеров текущей медитации
      const code = this.items.findIndex((item) => item.code === currentSpeakerCode);

      if (code > -1) {
        const currentCode = this.items[code].code;
        localStorage.setItem('NLMK_SPEAKER_CODE', currentCode);

        this.items[code].active = true;

        // src ранее заданного спикера
        this.setCurrenAudioSrc(this.items[code].audio);
      } else {
        const currentCode = this.items[0].code;
        localStorage.setItem('NLMK_SPEAKER_CODE', currentCode);

        this.items[0].active = true;

        // src первого спикера, тк ранее установленный не найден
        this.setCurrenAudioSrc(this.items[0].audio);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "Toggle";
</style>
